import cn from "classnames";
import React from "react";
import { AlignmentOptions } from "components/pdfViewer/types";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import Button from "components/Button";
import useForm from "modules/forms/hooks/useForm";
import useFormFlow from "modules/forms/hooks/useFormFlow";

export type SubmitButtonType = Omit<FormBlockType, "data"> & {
    data: {
        label: string;
        align: AlignmentOptions
    },
}

export default function SubmitButton(block: SubmitButtonType) {
    const { form } = useForm();
    const { isSubmitting } = useFormFlow();
    const { align, label } = block.data;
    const alignmentCn = cn(
        { "mr-auto": align == "left" },
        { "ml-auto": align == "right" },
        { "mx-auto": align == "center" }
    );

    return (
        <Button
            label={label}
            colors={{
                background: form.branding.button_background_color,
                text: form.branding.button_text_color
            }}
            className={`mt-8 ${alignmentCn}`}
            pending={isSubmitting}
            disabled={isSubmitting}
            type="submit"
        />
    );
}
